import fetch from 'cross-fetch'

import config from '../config'

const { statisticsApiUrl } = config

const toJson = resp => {
  const json = resp.json();
  return resp.ok
    ? json
    : json.then(err => {
        throw err
      })
}

const apiFetch = (endpoint, data, { method = 'GET' } = {}) => {
  let paramsString = '?';
  if(method === 'GET' && data) {
    paramsString = new URLSearchParams(data);
  }
  return fetch(`${statisticsApiUrl}${endpoint}?${paramsString}`, { method }).then(toJson)
};

export default apiFetch
